import { OrderSuccessFailureStatuses } from 'state/order/constants';
import { OrderStatus } from 'state/order/types';

import { CartEntryType } from './cart/types';

interface HydrationStatus {
  processed: boolean;
  executing: boolean;
  error: boolean;
}

interface ShouldRedirectToMenuParams {
  isMounted: boolean;
  hydrationStatus: HydrationStatus;
  cartEntries: any[];
  orderStatus: OrderStatus;
  serviceMode: any;
  orderServiceMode: any;
  hasItemsOrCombos: boolean;
}

/**
 * Determines if the user should be redirected to the menu based on cart state and conditions
 */
export const shouldRedirectToMenu = ({
  isMounted,
  hydrationStatus,
  cartEntries,
  orderStatus,
  serviceMode,
  orderServiceMode,
  hasItemsOrCombos,
}: ShouldRedirectToMenuParams): boolean => {
  // Don't redirect if component is not mounted or hydration is still executing
  if (!isMounted || hydrationStatus.executing) {
    return false;
  }

  const hydrationSuccessful =
    hydrationStatus.processed && !hydrationStatus.executing && !hydrationStatus.error;

  const cartIsEmpty = cartEntries.length === 0;
  const isPriceOrderInProgress = OrderSuccessFailureStatuses.inProgress.pos.includes(
    orderStatus as OrderStatus
  );
  const isServiceModeSet = !!serviceMode || !!orderServiceMode;

  // Redirect to Menu if:
  // - Cart is empty
  // - Selected offer is null
  // - The order has not been inserted or has been requested
  // - Hydration was completed successfully
  // Or
  // - Service mode is null
  return (
    (hydrationSuccessful && cartIsEmpty && !isPriceOrderInProgress) ||
    !hasItemsOrCombos ||
    !isServiceModeSet
  );
};

export const isItemOrCombo = (entry: any) => {
  const isItemOrCombo =
    entry.type === CartEntryType.combo ||
    entry.type === CartEntryType.offerCombo ||
    entry.type === CartEntryType.item;
  return isItemOrCombo && !entry.isDonation && !entry.isExtra;
};

export const cartHasItemsOrCombos = (cartEntries: any[]) => {
  return cartEntries.some(isItemOrCombo);
};
